<template>
    <div>

        <div>
            <div class="filter-container" v-show='!filterShown'>
                <input v-on:keyup.enter="applyFilters" type="text" :placeholder="this.$t('translations.search')" ref="search" class="basic-search col-md-21">
                <button v-on:click='applyFilters' class="btn mt-1 btn-search-modal"><img src="img/icon-search.svg"></button>
                <button class="btn btn-outline-primary btn-round btn-sm mt-2" v-on:click.prevent='switchFilter'>{{ $t('translations.advanced_search')}}</button>
                <!-- <div class="btn-filter-toggle">

                    <button type="button" class="btn btn-info btn-sm" data-toggle="modal" data-target="#searchModal">Search</button>
                    <button type="button" class="btn btn-info btn-sm" data-toggle="modal" data-target="#filterModal">Filter</button>
                </div> -->
            </div>

            <div class="filter-container pt-1 border-bottom" v-bind:style='{visibility: (filterShown ? "visible" : "hidden"), height: (filterShown ? "auto" : "0px")}'>
                <p v-if='subtitle' class="pl-3"><small>{{subtitle}}</small></p>
                    <local-error v-bind:inline='[]'></local-error>
                    <div class="row-nm  mb-1" v-for="(filter, index) in filters" :key='filter.id'>
                        <select style='display: none;' class="filter-field custom-select col-md-0" :data-index="index" v-on:change='updateFilterField' >
                            <option v-for="value in filterFields" :key='value.field' :value='value.field' :selected='filter.field==value.field ? "selected" : ""'>{{autobrand(value.title)}}</option>
                        </select>
                        <label class="col-md-10 col-form-label">{{autobrand(filter.title) | capitalise}}</label>
                        <select style='display: none' class="custom-select col-md-5" :ref='"filter-type-" + index' :name='"operator-" + index' :data-index="index" v-on:change='updateFilterType'>
                            <template v-if='(filterFields[filter.field].values instanceof Array)'>
                                <option value='='>{{ $t('translations.is')}}</option>
                                <option value='!='>{{ $t('translations.is_not')}}</option>
                            </template>
                            <template v-else-if='filterFields[filter.field].type == "date"'>
                                <option value='='>{{ $t('translations.is')}}</option>
                            </template>
                            <template v-else>
                                <option value='like'>{{ $t('translations.contains')}}</option>
                                <option value='not like'>{{ $t('translations.does_not_contain')}}</option>
                            </template>
                        </select>
                        <autocomplete v-if='showAutocomplete(filter)'
                            v-model='filters[index].value' 
                            class='form-control col-13' 
                            :ref='"filter-value-" + index' 
                            :name='"value" + index' 
                            :data-index="index" 
                            v-on:change='updateFilterValue'
                            :source='objectPropKeysToAutocomplete(filterFields[filter.field].values)'
                            results-value='value'
                            @clear='filters[index].value = null'>
                        </autocomplete>
                        <select v-else-if='(filterFields[filter.field].values instanceof Object)' v-model='filters[index].value' class='custom-select col-md-13' :ref='"filter-value-" + index' :name='"value" + index' :data-index="index" v-on:change='updateFilterValue'>
                            <option value=''>{{$t('translations.please_select')}}</option>
                            <template v-for="(item, key) in filterFields[filter.field].values">
                                <option v-if='item instanceof Object' :key='item.value' :value='item.value' :selected='filter.value == item.id ? "selected" : ""'>{{tIfExists(item.name)}}</option>
                                <option v-else :key='key' :value='key' :selected='filter.value == key ? "selected" : ""'>{{tIfExists(item)}}</option>
                            </template>

                        </select>

                        <template v-else-if='filter.field=="dob"'>
                            <vue-dob-picker :ref='"filter-value-" + index' container-class='col-md-13 row-nm justify-content-between' input-class="form-control form-control-sm nospin" v-on:keyup.enter="applyFilters" :type="filterFields[filter.field].type ? filterFields[filter.field].type : 'text'" :name='"value" + filter.field' :value='filter.value' :data-index="index" v-on:change='updateFilterValue'>
                            </vue-dob-picker>
                        </template>
                        <input v-else :ref='"filter-value-" + index' class="form-control form-control-sm col-md-13" v-on:keyup.enter="applyFilters" :type="filterFields[filter.field].type == 'date' ? filterFields[filter.field].type : 'text'" :name='"value" + filter.field' :value='filter.value' :data-index="index" v-on:change='updateFilterValue'>

                        <!-- <button class="btn btn-secondary" v-on:click='addFilter' :data-index='index'>+</button>
                        <button class="btn btn-secondary" v-on:click='removeFilter' :data-index='index' :disabled='filters.length <= 1'>-</button> -->
                    </div>


                <div class="form-group form-inline col-auto">
                    <!-- <button class="btn btn-outline-primary btn-round btn-sm" v-on:click.prevent='switchFilter'>Basic Search</button> -->
                    <router-link v-if='show_duplicates' to="/userduplicate-list" class="btn btn-light btn-sm btn-round mr-auto">
    					<span>{{ $t('translations.manage_duplicates') }}</span>
    				</router-link>

                    <button class="btn btn-light btn-sm btn-round mr-2" v-on:click.prevent='clearFilters'>{{$t('translations.clear')}}</button>
                    <button class="btn btn-success btn-sm btn-round" v-on:click.prevent='applyFilters'>{{$t('translations.apply')}}</button>
                </div>

            </div>

        </div>

    </div>
</template>


<script>
export default {
    props: {
        "route": {}, 
        "model": {}, 
        "path": {}, 
        "modalid": {}, 
        "subtitle": {}, 
        "show_duplicates": {
            default: false
        }
    },
    data: function() {
        return {
          users: {},
          filterFields: {},
          filters: [],
          filterShown: true,
          search: "",
          filterId: 1,
          appliedFilters: null,
          errors: [],
        };
    },
    mounted() {

    },
    methods: {
        switchFilter() {
            this.filterShown = !this.filterShown;
            setTimeout(function() {
                if (this.filterShown) {
                    //alert(this.$refs["filter-value-0"]);
                    $(this.$refs["filter-value-0"]).focus();
                }
                else {
                    //alert(this.$refs.search);
                    $(this.$refs.search).focus();
                }
            }.bind(this), 1000);
        },
        clearFilters(event) {
            this.filters = [];
            this.appliedFilters = [];
            for(var index in this.filterFields) {
                var initialValue = "";
                if(this.filterFields[index].type == "checkbox-list") {
                    initialValue = [];
                }
                if(this.filterFields[index].type == "daterange") {
                    initialValue = {};
                }
                this.filters.push({
                    id: this.filterId++,
                    field: this.filterFields[index].field,
                    type: this.getMatchType(this.filterFields[index]),
                    field_type: this.filterFields[index].type,
                    value: initialValue,
                    title: this.filterFields[index].title
                });
            }
        },
        applyFilters() {
            if(this.filterShown) {
                this.search = "";
            }
            else {
                this.clearFilters()
            }
            this.errors = {};
            // for(var index = 0; index < this.filters.length; index++) {
            //     console.log(this.filters[index].title);
            //     console.log(this.filters[index].field_type);
            //     console.log(this.filters[index].value);
            //
            //     if(this.filters[index].field_type == 'number' && isNaN(this.filters[index].value)) {
            //         if(!this.errors.global) {
            //             this.errors.global = [];
            //         }
            //         this.errors.global.push("You have invalid values in the filter options");
            //         return false;
            //     }
            // }
            //$(this.$refs.modal).modal("hide");
            this.appliedFilters = JSON.parse(JSON.stringify(this.filters));
            this.$emit("filterUpdated");
            //this.$parent.getResults(1)
        },
        removeFilter(event) {
            console.log(this.filters);
            console.log($(event.target).data("index"));
            this.filters.splice($(event.target).data("index"), 1);
            console.log(this.filters);
        },
        filterHasValue(filter) {
            if(Array.isArray(filter.value)) {
                if(filter.value.length) {
                    return true;
                }
            }
            else {
                if(filter.value) {
                    return true;
                }
            }
            return false;
        },
        addFilter(event) {
            this.filters.push({
                id: this.filterId++,
                field: this.filterFields[Object.keys(this.filterFields)[0]].field,
                type: this.getMatchType(this.filterFields[Object.keys(this.filterFields)[0]]),
                value: ""
            });
        },
        // THIS IS ONLY USED EXTERNALLY FOR SETTING FILTERS FROM PARENT COMPONENTS.
        // DON'T USE THIS FUNCTION INTERNALLY TO THIS COMPONENT
        setFilter(name, type, value) {
            var index = this.filters.findIndex(obj => {
                return obj.field == name});

            if(index != -1) {
                this.filters[index].value = value;
                this.applyFilters();
            }
        },
        updateFilterField(event) {
            console.log("Field change: " + $(event.target).val());
            this.filters[$(event.target).data("index")].field = $(event.target).val(); //$(this.$refs["filter-type-" + $(event.target).data("index")]).trigger("change");

            if (this.filterFields[$(event.target).val()].values instanceof Array || this.filterFields[$(event.target).val()].values instanceof Object) {
                this.filters[$(event.target).data("index")].type = "=";
                this.filters[$(event.target).data("index")].value = this.filterFields[
                    $(event.target).val()
                ].values[0].key;
            }
            else {
                this.filters[$(event.target).data("index")].type = this.getMatchType(this.filterFields[$(event.target).val()]);
                this.filters[$(event.target).data("index")].value = "";
            }
        },
        updateFilterType(event) {
            console.log("Type change: " + $(event.target).val());
            this.filters[$(event.target).data("index")].type = $(event.target).val();
        },
        updateFilterValue(event) {
            if(event.target) {
                console.log("Value change: " + $(event.target).val());
                this.filters[$(event.target).data("index")].value = $(event.target).val();
            }
            else {
                this.filters[event.index].value = event.value;
            }

            // Without jQuery
            //console.log("Value change: " + event.target.dataset.index + ") " + event.target.value);
            //this.filters[event.target.dataset.index].value = event.target.value;

        },
        getFilterDefinition(filter) {
            var definition = this.$t(this.filterFields[filter.field].title);
            switch(filter.type) {
                case '=': definition += " is";break;
                case '!=': definition += " is not";break;
                case 'like': definition += " contains";break;
                case 'not like': definition += " does not contain"; break;
            }
            if(this.filterFields[filter.field].type == "date") {
                definition += " '" + this.formatDate(filter.value) + "'";
            }
            else if(this.filterFields[filter.field].values instanceof Array || this.filterFields[filter.field].values instanceof Object) {
                if(this.filterFields[filter.field].values[0] && this.filterFields[filter.field].values[0] instanceof Object) {
                    definition += " '" + this.filterFields[filter.field].values.find(obj => {return obj.value == filter.value}).name + "'";
                }
                else {
                    definition += " '" + this.filterFields[filter.field].values[filter.value] + "'";
                }
            }
            else {
                definition += " '" + filter.value + "'";
            }

            return definition;

        },
        getMatchType(field) {
            return (
                field.values instanceof Array 
                || field.values instanceof Object 
                || field.type == "date"
                || field.type == "daterange"
                || field.type == "number") ? "=" : "like";
        },
        showAutocomplete(filter) {
            // Easy way to disable these for debugging filters, as it is much harder to debug
            // with autocompletion turned on.
            // return false;

            if(Array.isArray(this.filterFields[filter.field].values)) {
                return this.filterFields[filter.field].values.length > 2;
            }
            else if(this.filterFields[filter.field].values instanceof Object) {
                return Object.keys(this.filterFields[filter.field].values).length > 2;
            }
        }
    }
};
</script>
